import { useField } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';

interface SelectorInputProps {
    // name: string;
    // label?: string;
    // placeholder?: string;
    // keys: [{ key: string; value: string }];
}

export const SelectorInput: React.FC<SelectorInputProps> = (props) => {
    return null;
    // const [field, meta] = useField({ name: props.name });

    // console.log(props);
    // return (
    //     <>
    //         <Form.Label>{props.label}</Form.Label>
    //         <Form.Control as="select" {...field}>
    //             <option value="0">Choose...</option>
    //             <option value="1">One</option>
    //             <option value="2">Two</option>
    //             <option value="3">Three</option>
    //         </Form.Control>
    //         {meta.touched && meta.error && <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>}
    //     </>
    // );
};
